import axios from "axios";
import { defaultPath } from "./defaultPath";
import { IUserItems } from "../types/Item";
import { $userInfoBd } from "../store/user";

export const user = {
    create: async (data:{
        "chat_id": string,
        "cookie": null,
        "ip": null,
        "name": string,
        "user_agent": null,
        "username": string,
        "telegram_id" : number | string,
        "invited_by" : string | null
    }) => {
        try {
            const res = await axios.post(`${defaultPath}users`,data);

            return res.data;
        } catch (err) {
            return null;
        }
    },
    get: async (id:string | number) => {
        try {
            const res = await axios.get(`${defaultPath}users/${id}`);

            return res.data;
        } catch (err) {
            return null;
        }
    },
    getCollection: async (): Promise<IUserItems> => {
        const user_id = $userInfoBd.getState()?.id;
        const res = await axios.get(`${defaultPath}user_collections/${user_id}`);

        return res.data;
    },
    getRaiting : async() => {
        const user_id = $userInfoBd.getState()?.id;
        const res = await axios.get(`${defaultPath}leaderboard?user_id=${user_id}`);

        return res.data;
    },
}